import React from "react";

const LoadingData: React.FC = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center"
            }}
        >
            <div className="custom-loader">loading</div>
        </div>
    );
};

export default LoadingData;